module.exports = __webpack_public_path__ + "img/x9-devs.67300ed9.png";